export function getStyledFont2BlueLink(text: string, href: string) {
    return `<a class="font2 color2" href="${href}">${text}</a>`;
}
